import { useState, useEffect, useCallback } from "react";

import api from "../../services/api";
import { pedidoEmVoo } from "../../services/pedidosEmVoo";
import { ehSiteDeStatus } from "../../helpers/planoStatus";

// Um GET /subscriptions/mine por vez, compartilhado entre os consumidores.
//
// O hook é montado pelo menu, pela barra de ícones e por vários componentes
// da conversa: na abertura da tela eram três requisições idênticas. Só o
// pedido EM VOO é compartilhado (e morre na troca de sessão — ver
// pedidosEmVoo); resolvido, some, e `recarregar` continua buscando fresco.
// `useMoedaAtiva` também bebe daqui.
export const buscarAssinatura = () =>
	pedidoEmVoo("assinatura", () => api.get("/subscriptions/mine"));

// O que a empresa logada contratou. Serve para esconder do menu o que ela
// não pode usar — sem isso a pessoa só descobre ao clicar e tomar um 403.
const useModules = () => {
	const [modules, setModules] = useState([]);
	const [assinatura, setAssinatura] = useState(null);
	const [exibicao, setExibicao] = useState({});
	const [carregando, setCarregando] = useState(true);

	const carregar = useCallback(async () => {
		try {
			const { data } = await buscarAssinatura();
			setModules((data.modules || []).map((m) => m.key));
			setAssinatura(data);
			setExibicao(
				Object.fromEntries((data.moduleDisplay || []).map((m) => [m.key, m]))
			);
		} catch (err) {
			// Falha aqui não pode esconder o sistema inteiro: sem resposta,
			// libera o menu e deixa o backend barrar quem não tiver acesso.
			setModules(null);
		}
		setCarregando(false);
	}, []);

	useEffect(() => {
		carregar();
	}, [carregar]);

	// modules === null significa "não consegui saber" — não esconde nada.
	const temModulo = useCallback(
		(chave) => modules === null || modules.includes(chave),
		[modules]
	);

	// Selo e aparência de "não contratado" definidos pelo super admin. Módulo
	// sem cadastro segue o padrão antigo: sem selo, com cadeado.
	const exibicaoModulo = useCallback(
		(chave) => ({
			stage: exibicao[chave]?.stage || "stable",
			lockedDisplay: exibicao[chave]?.lockedDisplay || "lock",
		}),
		[exibicao]
	);

	return {
		modules,
		assinatura,
		temModulo,
		exibicaoModulo,
		carregando,
		recarregar: carregar,
		// Plano do produto "só Status" (ver helpers/planoStatus). Cada chamada
		// tem estado próprio: enquanto a dela carrega, no status.* supõe o
		// plano de status — senão o menu completo pisca antes de trocar.
		// Tipo de canal (família da tela de Conexões) desligado pelo super admin.
		canalLigado: (familia) =>
			!(assinatura?.disabledChannels || []).includes(familia),
		statusOnly: carregando
			? ehSiteDeStatus()
			: Boolean(assinatura?.statusOnly),
	};
};

export default useModules;
